export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const SHEBA_REGEX = /^[0-9]{2}([0-9]{3})[0-9]{19}$/
export const CARD_REGEX = /^\d{4}-\d{4}-\d{4}-\d{4}$/
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).*$/

// Convert all Persian and Arabic numbers to English
export function normalizeDigits(input: string): string {
  return input
    .replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)))
}

// Normalize mobile number (remove prefix and convert digits)
export function normalizeMobile(input: string): string {
  if (!input) return ''
  let digits = normalizeDigits(input.trim())
  if (digits.startsWith('+98')) {
    digits = digits.slice(3)
  } else if (digits.startsWith('98')) {
    digits = digits.slice(2)
  } else if (digits.startsWith('09')) {
    digits = digits.slice(1)
  }
  digits = digits.replace(/\D/g, '')
  digits = digits.slice(-10)
  if (digits.length !== 10) return ''
  return `+98${digits}`
}

// Validate mobile number (Iran format)
export function isValidMobile(input: string): boolean {
  const normalized = normalizeMobile(input)
  return /^\+989\d{9}$/.test(normalized)
}

// Validate OTP code with custom length (default 5)
export function isValidOtp(input: string, length = 5): boolean {
  const code = normalizeDigits(input)
  return new RegExp(`^\\d{${length}}$`).test(code)
}

export const isValidEmail = (email: string): boolean => {
  return EMAIL_REGEX.test(email)
}
